import { Component, ComponentFactoryResolver, NgZone, OnInit, ViewChild, ViewContainerRef, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { INamedClass } from '../common/iNamedClass';
import { LauncherComponent } from '../common/launcher/launcher.component';
import { LoadManagerService } from '../common/loadingOverlay/loadManager.service';
import { LoggerService } from '../common/logging/logger.service';
import { OfficeSelectorService } from '../common/officeSelector/officeSelector.service';
import { DashboardMenuTabSelectorService } from '../dashboardCommon/services/dashboardMenuTabSelector.service';
import { ImpersonationService } from '../auth/apigee/impersonation.service';
import { FeaturePermissionsService } from '../auth/raas/featurePermissions.service';
import { StaticDashboardDirectDefinitionComponent } from './staticDashboardDirectDefinition.component';
import { ImpersonationMenuComponent } from '../common/impersonationMenu/impersonationMenu.component';
import { TabEntry } from '../dashboardCommon/tabEntry';
import { ApigeeService } from '../auth/apigee/apigee.service';

@Component({
  selector: 'dashboardDirect',
  templateUrl: './dashboardDirect.component.html',
  styleUrls: ['./dashboardDirect.component.css'],
  providers: [LoadManagerService],
  standalone: false
})
export class DashboardDirectComponent implements OnInit, INamedClass, AfterViewInit {
  public getClassName() { return "DashboardDirectComponent"; }

  public tabEntries: TabEntry[] = [
    new TabEntry("gestionAdministrativaMenuOption", "Gestión Administrativa")
  ];

  private mBusy: boolean;
  private mIsProfessionals: boolean = false;
  private mLoadStatusUpdatedSubscription: Subscription;
  @ViewChild('dashboardItemContainer', { read: ViewContainerRef }) private itemContainer: ViewContainerRef;
  @ViewChild(LauncherComponent) private launcher: LauncherComponent;
  @ViewChild(ImpersonationMenuComponent) private impersonationMenu: ImpersonationMenuComponent;
  private staticDashboardDirectDefinition: StaticDashboardDirectDefinitionComponent;

  public get isProfessionals(): boolean {
    return this.officeSelectorService.selectedOffice && !this.officeSelectorService.selectedOffice.isTEA && this.mIsProfessionals;
  }

  public get isFundation(): boolean {
    return this.officeSelectorService.selectedOffice && this.officeSelectorService.selectedOffice.isFundation;
  }

  private mSelectedTab: number;
  private mSelectedTabChangedSubscription: Subscription;
  public get selectedTab(): number { return this.mSelectedTab; }

  private mSelectedOfficeUpdatedSubscription: Subscription;
  public showKpis: boolean = true;

  private routerEventsSubscription: Subscription;

  constructor(private viewContainerRef: ViewContainerRef,
    private factoryResolver: ComponentFactoryResolver,
    private zone: NgZone, private router: Router,
    private logger: LoggerService,
    private apigeeService: ApigeeService,
    private impersonationService: ImpersonationService,
    private loadManagerService: LoadManagerService,
    private selectedTabService: DashboardMenuTabSelectorService,
    private officeSelectorService: OfficeSelectorService,
    private featurePermissionsService: FeaturePermissionsService) {
  }

  public get busy(): boolean {
    return this.mBusy;
  }

  public get impersonationEnabled(): boolean {
    return this.impersonationService.canImpersonate;
  }

  public get isUPayroll(): boolean {
    return this.officeSelectorService.selectedOffice && this.officeSelectorService.selectedOffice.isUPayroll;
  }

  public async ngOnInit(): Promise<void> {
    this.routerEventsSubscription = this.router.events.subscribe((event) => {
    });

    this.mLoadStatusUpdatedSubscription = this.loadManagerService.loadStatusUpdated.subscribe((value) => {
      this.zone.run(() => this.mBusy = value);
    });

    this.mSelectedTabChangedSubscription = this.selectedTabService.selectedTabChanged.subscribe((index) => this.mSelectedTab = index);
    this.mSelectedTab = this.selectedTabService.selectedTab;

    this.mSelectedOfficeUpdatedSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe((value) => {
      this.zone.run(() => {
        this.showKpis = value ? value.isTEA : false;

        if ((this.mIsProfessionals && !(value ? value.isTEA : false)) || this.isFundation) {
          this.zone.run(() => this.router.navigate(['home']));
        }
        else if (!this.isUPayroll) this.zone.run(() => this.router.navigate(['dashboard']));
      });
    });

    this.loadManagerService.incLoadRequest();
  }

  public async ngAfterViewInit(): Promise<void> {
    try {
      let apigee = this.apigeeService;

      if (apigee.apiToken == null && (apigee.googleAuthToken == null || apigee.googleDirectoryToken == null)) {
        throw new Error("No credentials present");
      }
      else {
        await this.featurePermissionsService.professionalsEnabled().then(result => this.zone.run(() => this.mIsProfessionals = result));
      }

      setTimeout(() => {
        if (this.officeSelectorService.selectedOffice && !this.officeSelectorService.selectedOffice.isTEA) {
          if (this.mIsProfessionals || this.isFundation) this.zone.run(() => this.router.navigate(['home']));
          else this.zone.run(() => this.showKpis = false);
        }
        else if (this.officeSelectorService.selectedOffice == null || (this.officeSelectorService.selectedOffice && !this.officeSelectorService.selectedOffice.isUPayroll)) {
          this.zone.run(() => this.router.navigate(['dashboard']));
        }
        else {
          this.zone.run(() => this.showKpis = true);
        }
      }, 250);

    } catch (error) {
      this.zone.run(() => this.router.navigate(['login']));
    }
    finally {
      this.loadManagerService.decLoadRequest();
    }


    try {
      this.logger.traceActivity("Acceso a Dashboard");
      await this.loadDashboardItems();
    } catch (error) { }
  }

  private async loadDashboardItems(): Promise<void> {
    try {
      this.loadManagerService.incLoadRequest();
      let factory = this.factoryResolver.resolveComponentFactory(StaticDashboardDirectDefinitionComponent);
      this.staticDashboardDirectDefinition = this.itemContainer.createComponent(factory).instance;
    } catch (error) {
      throw error;
    } finally {
      this.loadManagerService.decLoadRequest();
    }
  }

  public ngOnDestroy(): void {
    if (this.routerEventsSubscription) this.routerEventsSubscription.unsubscribe();
    if (this.mSelectedOfficeUpdatedSubscription) this.mSelectedOfficeUpdatedSubscription.unsubscribe();
    if (this.mLoadStatusUpdatedSubscription) this.mLoadStatusUpdatedSubscription.unsubscribe();
    if (this.mSelectedTabChangedSubscription) this.mSelectedTabChangedSubscription.unsubscribe();
  }


}
